import { html } from '$utils/greet';

window.Webflow ||= [];
window.Webflow.push(() => {
  document.querySelector('[data-element="fs-embed"]').innerHTML = html;
});
